module.exports = __webpack_public_path__ + "static/media/2.dde03ce6.png";